import { deleteRequest, getRequest, getFileRequestWithToken, postRequest, putRequest, postUploadRequest, uploadRequest } from "../../apiClient";
import { NewsEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetNews = async (queryString: any) => {
    var _url = NewsEndpoint.NEWS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetNewsById = async (id: string | number) => {
    var _url = NewsEndpoint.NEWS_BY_ID_URL(id)
    var res = await getRequest(_url);

    return res;
};

export const GetNewsCoverPhotoById = async (id: string | number) => {
    var _url = NewsEndpoint.NEWS_COVER_PHOTO_BY_ID_URL(id);
    var res = await getFileRequestWithToken(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateNewsService = async (param: any) => {
    var _url = NewsEndpoint.NEWS_URL
    var res = await postUploadRequest(_url, param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditNewsService = async (id: string | number, param: any) => {
    var _url = NewsEndpoint.NEWS_BY_ID_URL(id);
    var res = await uploadRequest(_url, param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteNewsService = async (id: string | number, param: any) => {
    var _url = NewsEndpoint.NEWS_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};
//#endregion